import { Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useState, useEffect } from 'react';
import { saveComment } from 'src/apis/collaborator';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

export default function CommentTextArea({ id, comment }) {
  const [value, setValue] = useState('');
  const maxLength = 800;

  const { t } = useTranslation();

  useEffect(() => {
    if (!!comment) {
      setValue(comment)
    }
  }, [comment])

  const onSave = async () => {
    try {
      await saveComment(id, value);
      notification.success({ message: t("collaboratorComments.successMessage") })
    } catch (error) {
      notification.error({ message: t("collaboratorComments.errorMessage") })
    }
  }

  return (
    <div className="textarea-container">
      <label className="textarea-label">{t('collaboratorComments.label')}</label>
      <TextArea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        maxLength={maxLength}
        placeholder={t('collaboratorComments.placeholder')}
        rows={6}
        className="textarea-input"
      />
      <div className="textarea-footer">
        <span>{value.length}/{maxLength} {t('charsLeft')}</span>
        <Button type="primary" className="save-button" disabled={value.length <= 0} onClick={onSave}>{t('save').toUpperCase()}</Button>
      </div>
    </div>
  );
}